import {
  getEntrepreneursCubeDimensionValues
} from "./get-entrepreneurs-cube-dimension-values";

export const getEntrepreneursTecRelationshipTypes = () => {
  return getEntrepreneursCubeDimensionValues("teamMemberTecRelationshipType");
};
